import { queryOptions, useQuery } from '@tanstack/react-query'

import { TourDocumentApi } from 'shared/api/tours/document-data'

import { mapDocumentData } from './map-document-data'

export const tourDocumentQueryKey = (documentId?: string) =>
  ['tours', 'document', documentId] as const

export const tourDocumentQueryOptions = (documentId?: string) =>
  queryOptions({
    queryKey: tourDocumentQueryKey(documentId),
    queryFn: async ({ signal }) => {
      if (!documentId) {
        throw new Error('Document ID is required')
      }

      const { data: response } = await TourDocumentApi.getDocumentData(
        documentId,
        signal,
      )

      return mapDocumentData(response.data)
    },
    staleTime: 0,
    retry: false,
    networkMode: 'always',
  })

export const useTourDocument = (documentId?: string) =>
  useQuery({
    ...tourDocumentQueryOptions(documentId),
    enabled: Boolean(documentId),
  })
